import React from 'react';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { ButtonGroup } from '@r1-frontend/ui-react/components/buttons/buttonGroup/ButtonGroup';
import { WithSkeleton } from '@r1-frontend/ui-react/components/loaders/Skeleton';

type TSubmitButtonProps = {
    handleConfirm: () => void,
    selectedDate: {weekday: string, from: string, to: string} | undefined,
    buttonIsDisabled: boolean,
}

const SubmitButton = ({ selectedDate, handleConfirm, buttonIsDisabled }: TSubmitButtonProps): JSX.Element => {
    return (
        <WithSkeleton width={280} height={48}>
            <ButtonGroup>
                <Button
                    onClick={handleConfirm}
                    disabled={buttonIsDisabled}
                >
                    <span>
                        Подтвердить {selectedDate && (
                        <>
                            {selectedDate.weekday.toLowerCase()} c {selectedDate.from}<sup>00</sup> по {selectedDate.to}<sup>00</sup>
                        </>
                    )}
                    </span>
                </Button>
            </ButtonGroup>
        </WithSkeleton>
    );
};

export default SubmitButton;
